import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import styles from "./RateSummaryRevenueChart.module.scss";
import { formatCurrency } from 'utils/helpers';
import classNames from 'classnames';

interface DataPoint {
  date: string;
  thisProperty: number;
  similarProperties: number;
}

interface RateSummaryRevenueChartProps {
  data: DataPoint[];
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload || !payload.length) return null;
  
  return (
    <div className={styles.tooltip}>
      <p className={styles.date}>{label}'25</p>
      <p className={classNames(styles.property, styles.this)}>
        <span>{formatCurrency(payload[0].value)}</span>
      </p>
      <p className={classNames(styles.property, styles.similar)}>
        <span>{formatCurrency(payload[1].value)}</span>
      </p>
    </div>
  );
};

export const RateSummaryRevenueChart: React.FC<RateSummaryRevenueChartProps> = ({ data }) => {
  return (
    <div className={styles.chart}>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            stroke="#000000"
            fontWeight="bold"
          />
          <YAxis 
            stroke="#000000"
            fontWeight="bold"
            tickFormatter={(value) => `$${value.toLocaleString()}`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="linear"
            dataKey="thisProperty"
            stroke="#000000"
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
          />
          <Line
            type="linear"
            dataKey="similarProperties"
            stroke="#000000"
            strokeWidth={2}
            strokeDasharray="5 5"
            dot={false}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}; 